import "bootstrap/dist/css/bootstrap.min.css";
import "./theme.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

const domain = "dev-bkkvxggv1jr7eotj.us.auth0.com";
const clientId = "kWtFFJrCFGSR4tt7C7lcTQECXQJUL6f3";
const audience = "https://trip-splitter-api";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: "openid profile email"
      }}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);